import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _noop from 'lodash/noop';


var isProduction = function isProduction() {
  return process.env.NODE_ENV === 'production';
};

var createFilterLogger = function createFilterLogger(component) {
  return function (propKey, allowed) {
    var props = _Object$keys(component.propTypes || {});
    if (!allowed && !props.includes(propKey)) {
      // eslint-disable-next-line no-console
      console.error('Not supported prop "' + propKey + '" passed to component "' + component.name + '".');
    }
  };
};

var isAllowed = function isAllowed(propKey, regexes, enhancer) {
  var allowed = regexes.some(function (regex) {
    return propKey.match(regex);
  });
  enhancer(propKey, allowed);
  return allowed;
};

var createFilter = function createFilter() {
  for (var _len = arguments.length, regexes = Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  return function (props) {
    var enhancer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return _Object$keys(props).filter(function (propKey) {
      return isAllowed(propKey, regexes, enhancer);
    }).reduce(function (dataProps, key) {
      return _extends({}, dataProps, _defineProperty({}, key, props[key]));
    }, {});
  };
};

var regexAria = /^aria-.+/;
var regexData = /^data-.+/;
var toRegExp = function toRegExp(arr) {
  return new RegExp('^(' + arr.join('|') + ')$');
};

/*
 * ! Update style-guide (components-common-props.md) also !
 * Bellowed list of props is described also in common section of ui-kit style-guide.
 * After you made change here, please update docs accordingly.
 */
export var htmlGlobalAttr = ['accessKey', 'contentEditable', 'contextMenu', 'dir', 'draggable', 'dropZone', 'hidden', 'id', 'lang', 'role', 'spellCheck', 'style', 'tabIndex', 'title', 'translate'];

var warnForEachProp = function warnForEachProp(props, componentName) {
  _Object$keys(props).forEach(function (propKey) {
    return (
      // eslint-disable-next-line no-console
      console.warn('Not supported prop "' + propKey + '" passed to component "' + componentName + '".')
    );
  });
};

export var warnAboutUnsupportedProps = isProduction() ? _noop : warnForEachProp;

export var makeFilterLogger = isProduction() ? function () {
  return _noop;
} : createFilterLogger;
export var getAriaAttributes = createFilter(regexAria);
export var getDataAttributes = createFilter(regexData);
export var getHtmlGlobalAttr = createFilter(toRegExp(htmlGlobalAttr));
export var getAllowedAttributes = createFilter(regexAria, regexData, toRegExp(htmlGlobalAttr));